module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/callouts/callouts.component.scss
// module id = ./src/app/callouts/callouts.component.scss
// module chunks = main